module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"counter":"{count} record total | {count} records total"},"searchbar":{"placeholder":"Search by text..."}}}')
  delete Component.options._Ctor
}
